export default "__VITE_ASSET__DwVBVXtH__"